var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.3333 25.6667H23.6666C24.5833 25.6667 25.3333 24.9167 25.3333 24.0001V2.33341C25.3333 1.41675 24.5833 0.666748 23.6666 0.666748H10.3333C9.41659 0.666748 8.66659 1.41675 8.66659 2.33341V24.0001C8.66659 24.9167 9.41659 25.6667 10.3333 25.6667ZM1.99992 22.3334H5.33325C6.24992 22.3334 6.99992 21.5834 6.99992 20.6667V5.66675C6.99992 4.75008 6.24992 4.00008 5.33325 4.00008H1.99992C1.08325 4.00008 0.333252 4.75008 0.333252 5.66675V20.6667C0.333252 21.5834 1.08325 22.3334 1.99992 22.3334ZM26.9999 5.66675V20.6667C26.9999 21.5834 27.7499 22.3334 28.6666 22.3334H31.9999C32.9166 22.3334 33.6666 21.5834 33.6666 20.6667V5.66675C33.6666 4.75008 32.9166 4.00008 31.9999 4.00008H28.6666C27.7499 4.00008 26.9999 4.75008 26.9999 5.66675Z","fill":"#F9FAFB"}));
}

Icon.defaultProps = {"width":"34","height":"26","viewBox":"0 0 34 26","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
